import { render, staticRenderFns } from "./ShipRecord.vue?vue&type=template&id=8ebcca48"
import script from "./ShipRecord.vue?vue&type=script&lang=js"
export * from "./ShipRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports